import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './shared/services/apis/usuario/auth.service';
import { isPlatformBrowser } from '@angular/common';
import { UsuarioLoginResponse } from './shared/services/responses/usuario/usuario-login.response';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!isPlatformBrowser(this.platformId)) {
      return false;
    }

    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/']);
      return false;
    }

    const token: UsuarioLoginResponse = this.authService.getUserInfos();

    if (token.master) {
      return true;
    }

    const modulo: number = route.data['modulo'];
    if (modulo) {
      const temAcessoModulo = token.listaModulos?.some(m => m.idModulo === modulo);
      if (!temAcessoModulo) {
        this.router.navigate(['/home']);
        return false;
      }
    }

    return true;
  }
}
